import { render, staticRenderFns } from "./ClientRegisterModal.vue?vue&type=template&id=67f95e4f&scoped=true&"
import script from "./ClientRegisterModal.vue?vue&type=script&lang=js&"
export * from "./ClientRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegisterModal.vue?vue&type=style&index=0&id=67f95e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f95e4f",
  null
  
)

export default component.exports